import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { ReactComponent as CrossIcon } from "../../assets/svg/close.svg";
import { Row, Col } from "react-bootstrap";
// import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
// import { createPOVApi, getLocationListApi, getPOVDetailsApi, updatePOVApi } from "./setup-api";
import AsyncSelect from "react-select/async";
import "./customer.css";
import SearchWithAPI from "../searchbox/searchbox.js";
import { getDeptApi, getDeviceApi, getLocationApi, getUserApi, saveDeviceApi, updateDeviceApi } from "./device-api.js";
import plus from "../../assets/svg/plus.svg";
import closeRed from "../../assets/svg/close-red.svg";

const DeviceCreateModal = ({ deviceId, onSuccess, onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [validations, setValidations] = useState({
        "device_name": "",
        "group_id": "",
        "status": "",
        "type": "",
        "signage_code": "",
        "domains":"",       
        "locations": "",
        "departments": "",
        "employees":"",
        "connection":''
    });
    useEffect(() => {
        if (deviceId != null) {
            getDeviceDetails();
        }
    }, [deviceId])

    const [deviceName, setDeviceName] = useState("");

    const [emailList, setEmailList] = useState([]);
    const [mobileList, setMobileList] = useState([]);
    const [groupOption, setGroupOption] = useState(null);
 const [locationsOption, setLocationsOption] = useState([]);
 const [departmentsOption, setDepartmentsOption] = useState([]);
 const [usersOption, setUsersOption] = useState([]);
 const [status, setStatus] = useState('Active');
const [deviceType, setDeviceType] = useState("Signage");
const [signageCode, setSignageCode] = useState("");
const [domainName, setDomainName] = useState("");
const [domainNameList, setDomainNameList] = useState([]);
 const [connection, setConnection] = useState('Single');
  const handleGroupDropdownChange = (option) => {
    console.log(option);
    setGroupOption(option);
  };
   
    const handleAddEmail = () => {
        const trimmedEmail = email.trim();

        // Simple email format regex
        const isValidEmail = (email) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!trimmedEmail) {
            setValidations((prev) => ({
                ...prev,
                email: "Email is required",
            }));
            return;
        }

        if (!isValidEmail(trimmedEmail)) {
            setValidations((prev) => ({
                ...prev,
                email: "Invalid email format",
            }));
            return;
        }

        // Clear validation if all is good
        setValidations((prev) => ({
            ...prev,
            email: "",
        }));
        setEmailList((prevList) => [...prevList, trimmedEmail]);

        // Add email logic here (e.g., pushing to a list, sending to backend, etc.)
        console.log("Email added:", trimmedEmail);

        // Optionally clear the input
        setEmail("");
    };
    const handleAddMobile = () => {
        const trimmedMobile = contactNo.trim();
        if (!trimmedMobile) return;

        setMobileList((prevList) => [...prevList, trimmedMobile]);
        setcontactNo(""); // clear input
    }; const handleRemoveEmail = (indexToRemove) => {
        setEmailList((prevList) =>
            prevList.filter((_, index) => index !== indexToRemove)
        );
    };
    const handleRemoveMobile = (indexToRemove) => {
        setMobileList((prevList) =>
            prevList.filter((_, index) => index !== indexToRemove)
        );
    };
    const getDeviceDetails = async () => {
        const response = await getDeviceApi(deviceId);
        if (response.status === 200) {
            if (response.data.success === true) {
                const deviceObj=response.data.device;
                setDeviceName(deviceObj.device_name ?? '');
                setGroupOption({value:deviceObj.group_id, label:deviceObj.group_name,});
                setLocationsOption(deviceObj.locations??[])
                setDepartmentsOption(deviceObj.departments??[])
                setUsersOption(deviceObj.employees??[])
                setDeviceType(deviceObj.type??"")
                setSignageCode(deviceObj.signage_code ?? '')
                setDomainNameList(deviceObj.domains ?? [])
                setStatus(deviceObj.status===true?'Active':'In-Active');
                setConnection(deviceObj.connection??'')
            }
           
        }
    }

    const modalStyle = {
        overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
        modal: { backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "718px", overflowY: "auto", minHeight: "fit-content" },
    };

    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [contactNo, setcontactNo] = useState("");


    const getLocationData = (inputValue, callback) => {
        setTimeout(async () => {
            console.log("Fetching transport options with term:", inputValue);
            const response = await getLocationApi(inputValue);
            if (response.status === 200) {
                if (response.data.success === true) {
                    const options = response.data.suggestionlist.map((item) => ({
                        value: String(item.value),
                        label: String(item.label),
                    }));
                    callback(options);
                }
            }
        }, 1000);
    };
    const getDepartmentData = (inputValue, callback) => {
        setTimeout(async () => {
            console.log("Fetching transport options with term:", inputValue);
            const response = await getDeptApi(inputValue);
            if (response.status === 200) {
                if (response.data.success === true) {
                    const options = response.data.suggestionlist.map((item) => ({
                        value: String(item.value),
                        label: String(item.label),
                    }));
                    callback(options);
                }
            }
        }, 1000);
    };
  const getUserOptions = (inputValue, callback) => {
    setTimeout(async () => {
      const response = await getUserApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value), // Ensure value is a string
            label: String(item.label), // Ensure label is a string
          }));
          callback(options); // Pass data to react-select
        }
      }
    }, 1000);
  };
  const handleUserDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    setUsersOption(selectedOptions);
  };
    const multiselectCustomStyles = {
        control: (provided) => ({ ...provided, backgroundColor: "#ffffff", borderRadius: "8px", border: "0.7px solid #E5E5E5", padding: "2px", fontWeight: "500", fontSize: "13px", color: "#212129" }),
        option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff", color: state.isSelected ? "#fff" : "#333", padding: 10 }),
        multiValue: (provided) => ({ ...provided, backgroundColor: "#F6F7F8", color: "#212129", borderRadius: "5px", padding: "2px 5px" }),
        multiValueLabel: (provided) => ({ ...provided, color: "#212129" }),
        multiValueRemove: (provided) => ({ ...provided, color: "#212129", cursor: "pointer", ":hover": { backgroundColor: "red", color: "white" } }),
    };










    const handleLocationChange = (selectedOptions) => {
        console.log(selectedOptions);
        setLocationsOption(selectedOptions);
    };
    const handleDeptChange = (selectedOptions) => {
        console.log(selectedOptions);
        setDepartmentsOption(selectedOptions);
    };
    const saveDevice = async () => {
        try {
            const payload = {
                "id":deviceId,
                "device_name": deviceName,
                "group_id": groupOption!=null?groupOption.value:"",
                "status": status==='Active'?true:false,
                "type": deviceType, //Signage|Domain
                "signage_code": signageCode,
                "domains":domainNameList,                
                "locations": locationsOption.map(item => item.value),
                "departments": departmentsOption.map(item => item.value),
                "employees":usersOption.map(item => item.value),
                "connection":connection
            };
            const dataAfterSanitize = {};
            Object.entries(payload).forEach(([key, value]) => {
                if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
                    dataAfterSanitize[key] = value;
                } else {
                    dataAfterSanitize[key] = DOMPurify.sanitize(value);
                }
            });
            let response;
            if (deviceId === null) {
                response = await saveDeviceApi(dataAfterSanitize);
            } else {
                response = await updateDeviceApi(dataAfterSanitize, deviceId);
            }


            console.log('response', response);
            if (response.status === 400) {
                const validationTemp = {
                    "device_name": "",
                "group_id": "",
                "status": "",
                "type": "",
                "signage_code": "",
                "domains":"",       
                "locations": "",
                "departments": "",
                "employees":"",
                "connection":""
                };

                // Safely iterate over the errors and pick the first message if available
                if (response.data?.error) {
                    Object.entries(response.data.error).forEach(([key, value]) => {
                        // Make sure value is an array and has at least one item
                        validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : '';
                    });
                }

                setValidations(validationTemp);
            } else {

            }

            if (response.data.success === true) {
                onSuccess(response.data)
            }


        } catch (err) {
            console.error("Error fetching category:", err);
        }
    };

    const addChip = () => {
    if (domainName && !domainNameList.includes(domainName)) {
      setDomainNameList([...domainNameList, domainName]);
      setDomainName('');
    }
  };

  const removeChip = (chipToRemove) => {
    setDomainNameList(domainNameList.filter(chip => chip !== chipToRemove));
  };

    return (
        <div style={modalStyle.overlay}>
            <div style={modalStyle.modal}>
                <div style={{ color: "#ffffff" }}>
                    <div className="mx-3 mt-1 style-justify-between">
                        <div>                         
                        <div className="add-item-modal-title">{deviceId != null ? "Edit " : "Add new"}  device</div>   
                        <div className="font-13-400-66737E">Enter the details for given fields to create a new device.</div>
                        </div>
                        <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
                    </div>
                    <div style={{ padding: "16px 24px" }}>
                        <Row style={{ width: "670px" }}>
                            <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                                <div className="field-title mb-2">
                                    Device Name<span style={{ color: "#FF4444" }}>*</span>
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field w-100" value={deviceName} onChange={(e) => setDeviceName(e.target.value)} />
                                <span className="field-error">{validations.device_name}</span>
                            </Col>
<Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
            <div className="field-title mb-2">
             
              Group Name<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <SearchWithAPI onDropdownChange={handleGroupDropdownChange} apiUrl={apiUrl + "get_group"} params={{}} placeholder={"Select"} selectedOption={groupOption} />
            <span className="field-error">{validations.group_id}</span>
          </Col>
          {/*  <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                      <div className="field-title mb-2">                       
                        Location<span style={{ color: "#FF4444" }}>*</span>{" "}
                      </div>
                      <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={apiUrl + "get_location"} params={{}} placeholder={"Select"} selectedOption={locationOption} />
                      <span className="field-error">{validations.location_id}</span>
                    </Col> */}

        <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
            <div className="field-title mb-2">Location</div>
            <AsyncSelect isMulti cacheOptions value={locationsOption} loadOptions={getLocationData} onChange={handleLocationChange} defaultOptions placeholder="Select Location" styles={multiselectCustomStyles} isClearable={false} />
            <span className="field-error">{validations.locations}</span>
          </Col>
            <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
            <div className="field-title mb-2">Department</div>
            <AsyncSelect isMulti cacheOptions value={departmentsOption} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select Department" styles={multiselectCustomStyles} isClearable={false} />
            <span className="field-error">{validations.departments}</span>
          </Col>
           
                    <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
            <div className="field-title mb-2">User</div>
            <AsyncSelect
              isMulti
              cacheOptions
              value={usersOption}
              loadOptions={getUserOptions}
              onChange={(selectedOptions) => {
                handleUserDropdownChange(selectedOptions);
              }}
              defaultOptions
              placeholder="Search email..."
              styles={multiselectCustomStyles}
              isClearable={false}
            />
            <span className="field-error">{validations.employees}</span>
          </Col>
         {/*  <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                    <div className="field-title mb-2">                       
                        Connection<span style={{ color: "#FF4444" }}>*</span>{" "}
                      </div>
                        <select className="input-field w-100" value={connection} onChange={(e) => { setConnection(e.target.value) }} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#FFFFFF', }}  >
                           <option value="Single">Single</option>
                            <option value="Multiple">Multiple</option>
                        </select>
                          <span className="field-error">{validations.connection}</span>           
                     </Col>  */}
  <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                    <div className="field-title mb-2">                       
                        Status<span style={{ color: "#FF4444" }}>*</span>{" "}
                      </div>
                        <select className="input-field w-100" value={status} onChange={(e) => { setStatus(e.target.value) }} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#FFFFFF', }}  >
                           <option value="Active">Active</option>
                            <option value="In-Active">In-Active</option>
                        </select>
                          <span className="field-error">{validations.status}</span>           
                     </Col> 
                      <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                      <div className="style-justify-start" style={{ flexWrap: 'wrap', gap: '8px' }}>
              <label className={`${deviceType === "Signage" ? 'radio-btn-txt-active' : 'radio-btn-txt-inactive'}`} >
                <input
                  type="radio"
                  name="options"
                  value="Signage"
                  checked={deviceType === "Signage"}
                  onChange={(event)=>{
                    setDeviceType(event.target.value);
                  }}
                  className="custom-radio"
                />
                <span className={`px-2 ${deviceType === "Signage" ? 'radio-btn-txt-active' : 'radio-btn-txt-inactive'}`}>Signage</span>
              </label>

             <label className={`${deviceType === "Domain" ? 'radio-btn-txt-active' : 'radio-btn-txt-inactive'}`} >
                <input
                  type="radio"
                  name="options"
                  value="Domain"
                  checked={deviceType === "Domain"}
                  onChange={(event)=>{
                    setDeviceType(event.target.value);
                  }}
                  className="custom-radio"
                />
                <span className={`px-2 ${deviceType === "Domain" ? 'radio-btn-txt-active' : 'radio-btn-txt-inactive'}`}>Domain</span>
              </label>
              </div>
              </Col>
             
               {deviceType === "Signage" &&( <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                    <div className="field-title mb-2">
                        Signage Code
                    </div>
                    <input type="text" placeholder="Enter here" className="input-field w-100" value={signageCode} onChange={(e) => setSignageCode(e.target.value)} />
                    <span className="field-error">{validations.signage_code}</span>
                </Col>)}
                {deviceType === "Domain" && (<Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                    <div className="field-title mb-2">
                        Domain Name<span style={{ color: "#FF4444" }}>*</span>
                    </div>
                    <div className="style-justify-center">
                    <input type="text" placeholder="Enter here" className="flex-1 input-field w-100" value={domainName} onChange={(e) => setDomainName(e.target.value)} />
                   <div className="ms-1 add-domain" onClick={addChip}><span className="icon">
                  <img src={plus} alt="add" className="btn-icon w-4 h-4" />
                </span> 
                </div>
                </div>
                <div style={{display:'flex', flexWrap: 'wrap', gap: '4px' }}>
        {domainNameList.map((chip,index) => (
          <Chip key={index} label={chip} onDelete={() => removeChip(chip)} />
        ))}
      </div>
                    <span className="field-error">{validations.domains}</span>
                </Col>)}

               
                        </Row>

                        <Row className="mt-3" style={{ width: "670px" }}>
                            <div className="style-justify-end">
                                <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
                                    Cancel
                                </div>
                                <div className="save-modal-btn style-justify-center" onClick={() => saveDevice()}
                                >
                                    {deviceId != null ? "Update " : "Save "}
                                </div>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceCreateModal;

const Chip = ({ label, onDelete }) => (
    <div className="d-flex" style={{ width:'fit-content', alignItems:'center', padding: '5px 10px', border: '1px solid #ccc', borderRadius: '15px', margin: '5px', display: 'inline-block'}}>
  <span style={{fontSize:'13px', fontWeight:'400', color:'#172B4D', }}>
    {label}
    
  </span>
  <img src={closeRed}  onClick={onDelete} alt="close" className="ms-2 btn-icon " />
  </div>
);